import { Tools } from '@babylonjs/core/Misc/tools'
import { CameraAngle } from '@lindberg/modelviewer/Cameras'
import ModelViewer, { Theme } from '@lindberg/modelviewer/ModelViewer'

export default class Preview extends HTMLElement {
	modelViewer = new ModelViewer()

	constructor() {
		super()
		this.append(this.modelViewer)

		if (window.navigator['standalone']) document.body.style.height = '100lvh'

		const params = new URLSearchParams(location.search)
		this.modelViewer.settings.theme = params.get('theme') as Theme || 'Titanium'
		this.modelViewer.settings.cameraSelectors = [CameraAngle.Front, CameraAngle.Perspective, CameraAngle.Side]
		this.modelViewer.settings.LOD = parseInt(params.get('lod'))
		this.modelViewer.settings.AO = params.get('ao') != 'false'

		if (params.get('reference')) {
			this.modelViewer.config =
				'productline=RIM&isRimless=false&engraving=HelloWorld!&theme=Precious&MODEL=ERIC+49%2322+&CLIP-ON=BROWN+FIXED+CLIP-ON%2FBROWN&INNERRIM=HORN+FIXED+HORN%2FH16&TEMPLE=RIM_BASIC%3BPOL+145+AU750%2FYG&LOWERRIM=RIM%3BPOL+FIXED+AU750%2FYG&UPPERRIM=RIM%3BPOL+FIXED+AU750%2FYG&NOSEPAD=MR%3BPOL+FIXED+AU750%2FYG'
		} else {
			this.modelViewer.config = location.search
		}
		this.modelViewer.load()

		// const params = new URLSearchParams(location.search)
		if (params.get('lighthouse')) {
			const message = document.createElement('div')
			message.className = 'message'
			this.modelViewer.shadowRoot.append(message)

			const h1 = document.createElement('h1')
			h1.className = this.modelViewer.settings.theme
			h1.innerText = 'Hello Lighthouse'
			message.append(h1)

			this.onclick = () => message.remove()
		}

		// const observer = new MutationObserver(async mutations => {
		// 	const target = this.modelViewer.shadowRoot.querySelector('realtime-cameraselector img[value=Perspective') as HTMLImageElement
		// 	if (target) {
		// 		observer.disconnect()
		// 		const canvas = document.createElement('canvas')
		// 		const context = canvas.getContext('2d')
		// 		canvas.width = canvas.height = 800

		// 		const iconSize = (target.naturalWidth + target.naturalHeight) / 2
		// 		context.rect(0, 0, canvas.width, canvas.height)
		// 		context.fillStyle = this.modelViewer.canvas.style.backgroundColor
		// 		context.fill()
		// 		context.drawImage(target, (target.naturalWidth - iconSize) / 2, (target.naturalHeight - iconSize) / 2, iconSize, iconSize, 0, 0, canvas.width, canvas.height)

		// 		document.head.insertAdjacentHTML(
		// 			'beforeend',
		// 			String.raw`
		// 			<meta name="apple-mobile-web-app-title" content="${this.modelViewer.configName}">
		// 			<link rel="apple-touch-icon" href="${canvas.toDataURL('image/png')}">
		// 		`
		// 		)
		// 	}
		// })
		// observer.observe(this.modelViewer.shadowRoot, { childList: true, attributes: false, subtree: true })
	}
}
customElements.define('realtime-preview', Preview)
